import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { apiClient } from '../../lib/api/client';
import { Button } from '../ui/Button';

interface CallAuditReportListItem {
  report_id: string;
  session_id: string;
  overall_quality_score?: number;
  overall_grade?: string;
  created_at?: string;
}

export const CallAuditReportsPage: React.FC<{ recruiterId?: string } > = ({ recruiterId }) => {
  const { user } = useAuth();
  const [reports, setReports] = useState<CallAuditReportListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resolvedRecruiterId = recruiterId || user?.id || '';

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await apiClient.getCallAuditReportsByRecruiter(resolvedRecruiterId);
        setReports(data || []);
      } catch (e: any) {
        setError(e?.message || 'Failed to load reports');
      } finally {
        setLoading(false);
      }
    };
    if (resolvedRecruiterId) load();
  }, [resolvedRecruiterId]);

  const downloadPdf = async (reportId: string) => {
    try {
      const blob = await apiClient.downloadCallAuditPdf(resolvedRecruiterId, reportId);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `call_audit_${reportId}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {}
  };

  if (loading) return <div className="p-6">Loading...</div>;
  if (error) return <div className="p-6 text-red-500">{error}</div>;

  return (
    <div className="p-6 space-y-4">
      <h2 className="text-xl font-semibold">Call Audit Reports</h2>
      <div className="space-y-3">
        {reports.length === 0 && (
          <div className="text-sm text-gray-500">No reports found.</div>
        )}
        {reports.map((r) => (
          <div key={r.report_id} className="flex items-center justify-between bg-white/60 dark:bg-black/30 rounded-lg p-4 border border-gray-200/50">
            <div className="space-y-1">
              <div className="text-sm font-medium">Report #{r.report_id.slice(0,8)}</div>
              <div className="text-xs text-gray-600">Quality Score: {r.overall_quality_score ?? '-'} | Grade: {r.overall_grade ?? '-'}</div>
              <div className="text-xs text-gray-500">Session: {r.session_id} | {r.created_at?.split('T')[0] ?? ''}</div>
            </div>
            <div className="flex gap-2">
              <Button size="sm" onClick={() => downloadPdf(r.report_id)}>Download PDF</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CallAuditReportsPage;


